import styled from 'styled-components'
import Button from '@/components/blocks/Button'

export const SignUpStyleWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: url(${({ theme }) => theme.images.signIn}) no-repeat center center;
  background-size: cover;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 380px;
  min-height: 375px;
  height: 375px;
  padding: 45px 33px;
  ${({ requirements }) => requirements && `
    padding: 47px 15px 50px;
  `}
  ${({ accepted }) => accepted && `
    padding: 45px 85px;
  `}
  background: ${({ theme }) => theme.colors.backgrounds.default};
  box-shadow: ${({ theme }) => theme.defaultBoxShadow(theme.colors.signInBackground)};
  border-radius: 4px;

  > svg,
  > img {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    margin-bottom: 22.5px;
  }
`

export const Title = styled.div`
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2rem;
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.colors.subTitle};
`

export const Text = styled.div`
  white-space: pre-wrap;
  font-size: 1.4rem;
  text-align: start;
  color: ${({ theme }) => theme.colors.colors.charts};
`

export const StyledButton = styled(Button)`
  margin-top: 30px;
`

export const SubmittedText = styled.div`
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2rem;
  display: flex;
  white-space: pre-wrap;
  text-align: center;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.colors.online};
`

export const SubmittedButton = styled(Button)`
  color: ${({ theme }) => theme.colors.colors.subTitle};
  text-decoration-line: underline;
  font-size: 1.2rem;
  align-items: center;
  justify-content: center;
  line-height: 3rem;
  margin-top: 10px;
`
